
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.063 51.738v18.45m-9.226 0h18.45M1 24.063v9.225a18.45 18.45 0 0018.45 18.45h9.225a18.45 18.45 0 0018.45-18.45v-9.225","stroke":"#FE9500","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M28.676 42.513H19.45a9.84 9.84 0 01-9.225-10.379V11.378A9.84 9.84 0 0119.45 1h9.225A9.84 9.84 0 0137.9 11.378v20.756a9.84 9.84 0 01-9.225 10.379z","fill":"#FFF2E0","stroke":"#FE9500","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.225 14.837h9.225m9.225 0H37.9m-27.675 9.226h9.225m9.225 0H37.9","stroke":"#FE9500","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    